import { gql } from '@api/gql';


export const USER_CART = gql(/* GraphQL */`
  query Cart {
    cart {
      ...WebCartCoreFragment
      items {
        ...WebCartItemCoreFragment
        product {
          code
          description
          family
        }
        store {
          code
          location {
            location_id
            alias
          }
        }
      }
      booking_requests {
        ...WebCartBookingRequestCoreFragment
      }
      summary {
        ...WebCartSummaryCoreFragment
      }
    }
  }
`);
